(function ($, Drupal, drupalSettings) {


    $(document).ready(function() {
        // Create donation tabs
        $('#donate--tabs').tabs();

        // Prepopulate amount on donate--button click
        $('.donate--button').click(function(event) {
            var amount = $(this).find('.donate--amount > span').text().trim();
            $(this).closest('.donation--tab').find('input[name="amount"]').val(parseFloat(amount));
            // Submit form
            var $form = $(this).closest('.donation--tab').find('.donation-field-form');
            $form.get(0).submit();
        });

    }); // document ready.


})(jQuery, Drupal, drupalSettings);
